const CLASS_LAZY = '.getLazy';
const ATTR_DATA = 'data-background';
const ATTR_BGHEIGHT = 'data-bgheight';
let lazyEls: Array <HTMLElement>;
let obj: Lazy;
let lazyBackgroundObserver: IntersectionObserver;

export default class Lazy {

    constructor() {
        lazyEls = Array.from(document.querySelectorAll(CLASS_LAZY));
        this.run();
        obj = this;
    }

    run() {
        document.addEventListener("DOMContentLoaded", function() {
            obj.observe();
        });
    }

    observe() {
        if ("IntersectionObserver" in window) {
            lazyBackgroundObserver = new IntersectionObserver(function(entries, observer) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                        var target = <HTMLElement>entry.target;
                        var imageUrl = target.getAttribute(ATTR_DATA);
                        let bgHeight = target?.getAttribute(ATTR_BGHEIGHT);

                        if(imageUrl != '') {
                            if(target.tagName == 'IMG') {
                            target.setAttribute('src', imageUrl);
                            } else {
                                target.style.backgroundImage = 'url('+imageUrl+')';
                                if(bgHeight) {
                                    target.style.backgroundPositionY = bgHeight + '%';
                                }
                            }
                        }
                        target.classList.add('loaded');
                        lazyBackgroundObserver.unobserve(entry.target);
                    }
                });
            });

            lazyEls.forEach(function(lazyBackground) {
                lazyBackgroundObserver.observe(lazyBackground);
            });
        }
    }

    loadAjaxContent() {
        lazyEls = Array.from(document.querySelectorAll(CLASS_LAZY));
        obj.observe();
    }
}